import { Component , EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {  DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Meta } from '../../../../models/Meta';
import { DatePipe,DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormGroup , FormControl, Validators} from '@angular/forms';
export const MY_FORMATS  ={
  parse: {dateInput: "DD-MM-YYYY"},
  display: {dateInput: "DD-MM-YYYY ",
  monthYearLabel: "MMM YYYY",
  dateA11yLabel: "DD-MM-YYYY",
   monthYearA11yLabel: "MMMM YYYY"}
};

@Component({
  selector: 'app-formulario-meta',
  templateUrl: './formulario-meta.component.html',
  styleUrls: ['./formulario-meta.component.scss'],
  providers: [DatePipe,DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class FormularioMetaComponent   {
  @Output() MetaCreada = new EventEmitter<any>();

  frmMeta : FormGroup;

  fechaI:any;
  fechaF:any;

  mdlMeta = new Meta();
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

  constructor(private decimalPipe: DecimalPipe, private datePipe: DatePipe) { 

   this.frmMeta = new FormGroup({
    FechaInicio: new FormControl('',[Validators.required]), 
    FechaFin: new FormControl('', [Validators.required]),
    Plazo: new FormControl('', [Validators.required]),
    Area: new FormControl('', [Validators.required]),
    MontoProyectado: new FormControl('', [Validators.required]),
   })

  }


  calcularDiferenciaDias(event){
   this.frmMeta.controls['Plazo'].setValue(this.diferenciaEntreDiasEnDias( this.frmMeta.controls['FechaFin'].value['_d'],this.frmMeta.controls['FechaInicio'].value['_d']));
  }

  EnviarMeta(){    
     this.frmMeta.controls['FechaInicio'].setValue(this.datePipe.transform(this.frmMeta.controls['FechaInicio'].value,'yyyy-MM-dd'));
     this.frmMeta.controls['FechaFin'].setValue(this.datePipe.transform(this.frmMeta.controls['FechaFin'].value,'yyyy-MM-dd'));
     this.MetaCreada.emit(this.frmMeta);
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
    valor =  this.decimalPipe.transform(this.cortarComa(this.mdlMeta[`${control}`]), `1.2-2` );
    this.mdlMeta[`${control}`] = valor;
  }

  cortarComa(numero: any): any {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }
}
